export default __webpack_public_path__ + "static/fabric-2a62c99dc12810aafb107857c4d98257.png";